export const CustomerContactDetailPublish = () => {
    return (
        <>
            <div className="content_wrap">
                <div className="fiter_top">
                    <h3 className="filter_heading">연락처 상세보기</h3>
                    <div className="filter_toolbar">
                        <button className="btn btn-outline-primary w-100px h-38px"><img src={process.env.PUBLIC_URL + "/assets/images/icon_hamburger_btn.png"} alt="" />목록</button>
                        <button className="btn btn-outline-dark w-100px h-38px"><img src={process.env.PUBLIC_URL + "/assets/images/icon_cross.png"} alt="" />삭제</button>
                    </div>
                </div>
                <h5 className="subheading">연락처 정보</h5>
                <div className="table_scroll mb-0">
                    <table className="table table-bordered my_table table_detail">
                        <tbody>
                            <tr>
                                <th style={{ width: "16.66%" }}>이름</th>
                                <td colSpan={3}>홍길동</td>
                            </tr>
                            <tr>
                                <th style={{ width: "16.66%" }}>생성일자</th>
                                <td style={{ width: "33.34%" }}>2024-05-05</td>
                                <th style={{ width: "16.66%" }}>생성자</th>
                                <td>최길동</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div className="content_wrap">
                <h5 className="subheading mt-0">연락처 상세정보</h5>
                <div className="table_scroll mb-0">
                    <table className="table table-bordered my_table table_detail">
                        <tbody>
                            <tr>
                                <th style={{ width: "16.66%" }}>계정</th>
                                <td style={{ width: "33.34%" }}>abcd@it.com</td>
                                <th style={{ width: "16.66%" }}>컨택 경로</th>
                                <td>전화 상담</td>
                            </tr>
                            <tr>
                                <th>이름</th>
                                <td>홍길동</td>
                                <th>직함</th>
                                <td>대리</td>
                            </tr>
                            <tr>
                                <th>회사명</th>
                                <td>(주)MDSTECH</td>
                                <th>회사 이메일</th>
                                <td>sh@mdstech.com</td>
                            </tr>
                            <tr>
                                <th>산업구분</th>
                                <td>산업구분 내용</td>
                                <th>회사 이메일 수신여부</th>
                                <td>수신</td>
                            </tr>
                            <tr>
                                <th>부서</th>
                                <td>부서명</td>
                                <th>팀</th>
                                <td>A팀</td>
                            </tr>
                            <tr>
                                <th>직무</th>
                                <td>SW 개발</td>
                                <th>휴대폰</th>
                                <td>010-1111-1111</td>
                            </tr>
                            <tr>
                                <th>근무처 전화</th>
                                <td>031-111-111</td>
                                <th>개인 이메일</th>
                                <td>abc@gmail.com</td>
                            </tr>
                            <tr>
                                <th>팩스</th>
                                <td>02)121-1111</td>
                                <th>개인 이메일 수신여부</th>
                                <td>수신</td>
                            </tr>
                            <tr>
                                <th>메모</th>
                                <td colSpan={3}></td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>

        </>
    );
}